export const scrollDetector = () => {
  return document.documentElement.scrollTop > 0
  || !!document.documentElement.querySelector('.cdk-overlay-container')?.hasChildNodes()
}
